import Route from '@ember/routing/route';

export default class StadionRoute extends Route {}
